import { render, staticRenderFns } from "./setbonus.vue?vue&type=template&id=b2c280f0"
import script from "./setbonus.vue?vue&type=script&lang=js"
export * from "./setbonus.vue?vue&type=script&lang=js"
import style0 from "./setbonus.vue?vue&type=style&index=0&id=b2c280f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports